import React, { useId, useState } from "react";
import { connect } from "react-redux";
import { NavBarOptions } from "./NavBarOptions";
import Text from "../Common/Text";
import Colors from "../../themes/Colors";
import {
  MenuNavbar,
  Menu,
  MenuItem,
  DropdownMenu,
  DropdownMenuItem,
} from "./HeaderStyles";
import CustomButton from "../CustomButton/CustomButton";
import useEmpresa from "../../hooks/useEmpresa";
import CheckRender from "../Common/CheckRender";
import { getStandVirtualFullUrl } from "../../containers/autorizacion/utils/AutorizacionUtils";
import { PROGRAMA, EMPRESA } from "../../utils/Constant";

const NavOptionRender = ({
  title,
  submenu,
  hasSubmenu,
  redirectTo,
  isStandVirtual,
  isPyp,
  color,
  hoverColor,
  tokenStandVirtual,
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const goToPath = (option) => {
    window.location.href = option.redirectTo;
  };

  const onClickSingleOption = () => {
    if (isStandVirtual) {
      const newTab = window.open(
        getStandVirtualFullUrl(tokenStandVirtual),
        "_blank"
      );

      newTab.focus();

      return;
    }

    if (isPyp) {
      window.location.href = redirectTo+'?program='+PROGRAMA.PROMOCION_PREVENCION.CODIGO;

      return;
    }

    window.location.href = redirectTo;
  };

  const id = useId();

  const empresa = useEmpresa();

  if (hasSubmenu) {
    return (
      <MenuItem onClick={toggleDropdown}>
        <CustomButton
          label={title}
          weight={"bold"}
          onClick={toggleDropdown}
          bgColor={color}
          hoverColor={hoverColor}
        />

        <DropdownMenu isOpen={isDropdownOpen}>
          {submenu?.map((item, index) => {
            return (
              <DropdownMenuItem
                key={`${id}-${index}`}
                onClick={() => goToPath(item)}
                backGroundHover={empresa?.COLOR_PRINCIPAL}
              >
                <Text
                  size="15px"
                  color={Colors.primaryPrimera}
                  hoverColor={Colors.white}
                >
                  {item?.subtitle}
                </Text>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenu>
      </MenuItem>
    );
  } else {
    return (
      <MenuItem onClick={onClickSingleOption}>
        <CustomButton label={title} weight={"bold"} />
      </MenuItem>
    );
  }
};

const CustomMenuNavBar = (props) => {
  const id = useId();

  const empresa = useEmpresa();

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  const { isStandVirtual, tokenStandVirtual, prestador } = props?.authUserData;

  const getButtonColor = (type) => {
    return type === "principal"
      ? empresa?.COLOR_PRINCIPAL
      : empresa?.COLOR_SECUNDARIO;
  };

  const getHoverColor = (type) => {
    return type === "principal"
      ? empresa?.COLOR_SECUNDARIO
      : empresa?.COLOR_PRINCIPAL;
  };

  const showOption = (item) => {
    return (
      (!item?.isStandVirtual && !item.isPyp) ||
      (item.isStandVirtual && isStandVirtual) ||
      (item.isPyp && prestador.pyp && isPrimera)
    );
  };

  return (
    <MenuNavbar>
      <Menu>
        {NavBarOptions.map((item, index) => {
          return (
            <CheckRender key={`${id}-${index}`} allowed={showOption(item)}>
              <NavOptionRender
                tokenStandVirtual={tokenStandVirtual}
                title={item?.title}
                submenu={item?.submenu}
                hasSubmenu={item?.hasSubmenu}
                redirectTo={item?.redirectTo}
                isStandVirtual={item?.isStandVirtual}
                isPyp={item?.isPyp}
                color={getButtonColor(item?.type)}
                hoverColor={getHoverColor(item?.type)}
                key={`${id}-${index}`}
              />
            </CheckRender>
          );
        })}
      </Menu>
    </MenuNavbar>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CustomMenuNavBar);
